import { z } from "zod";
import type { Color } from "../color";
import type { ColorSet } from "../color-sets/color-set";
import type { ColorValue } from "../color-value";

const colorStringZodObject = z.object({
    _type: z.literal("COLOR_STRING"),
    asString: z.string(),
});
type ColorString = z.infer<typeof colorStringZodObject>;
type ColorStrict = ColorString | Color | ColorValue | ColorSet;

export { colorStringZodObject };
export type { ColorStrict, ColorString };
